import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { getPartnerPaymentRecordById } from '../../services'
import { PartnerQueryKeys } from '@/modules/manage-player/keys'
import { PartnerPaymentRecordModel } from '@/modules/manage-player/type'

export default function useQueryGetPartnerPaymentRecordById(
	partnerId: string,
	recordId: string,
	props?: Omit<
		UseQueryOptions<PartnerPaymentRecordModel>,
		'queryKey' | 'queryFn'
	>,
) {
	return useQuery({
		queryKey: [
			PartnerQueryKeys.GetPartnerPaymentRecordById,
			partnerId,
			recordId,
		],
		queryFn: () => getPartnerPaymentRecordById(partnerId, recordId),
		enabled: !!partnerId && !!recordId,
		...props,
	})
}
